import { defineComponent as _defineComponent } from 'vue'
import { vibrate } from '../utils/vibrate';
  import { useStore } from 'vuex';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ShowEqualizer',
  setup(__props, { expose }) {
  expose();

  const store = useStore();

  const updateShowEqualizer = (): void => {
    vibrate();
    store.commit('refreshShowEqualizer');
  };

const __returned__ = { store, updateShowEqualizer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})